// extracted by mini-css-extract-plugin
export default {"styled_info_card":"styles_styled_info_card__-i06v"};